import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const AcademiaAreaChart = ({
  data,
  xAxisDataKey,
  chartDataKey,
}: {
  data: Array<any>;
  xAxisDataKey: string;
  chartDataKey: string;
}) => {
  // rendering custom area chart component here
  return (
    <ResponsiveContainer width='100%' height='100%'>
      <AreaChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey={xAxisDataKey} />
        <YAxis />
        <Tooltip />
        <Area
          type='monotone'
          dataKey={chartDataKey}
          stroke='#8DD777'
          fill='#8DD777'
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AcademiaAreaChart;
